import { gsap } from 'gsap';
import { createStableResizeHandler } from '../viewport-utils';

function initRootAnimation(root: HTMLElement) {
    gsap.set(root, { opacity: 0 });

    // 固定
    gsap.to(root, {
        scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: '+=100%',
            scrub: true,
            pin: true,
            // markers: true,
        },
    });

    // 显示
    gsap.to(root, {
        scrollTrigger: {
            trigger: root,
            start: 'top bottom-=20%',
            end: '+=20%',
            scrub: true,
            // markers: true,
        },
        opacity: 1,
    });

    gsap.to(root, {
        scrollTrigger: {
            trigger: root,
            start: 'center top',
            end: '+=50%',
            scrub: true,
            // markers: {
            //     indent: 100,
            //     startColor: 'black',
            //     endColor: 'black',
            // },
            onUpdate: function () {
                const bgColor = window.getComputedStyle(root).backgroundColor;
                // 转换得到的颜色为rgba格式，如果需要特别格式请自行调整
                document.documentElement.style.setProperty(
                    '--dynamic-bg-color',
                    bgColor,
                );
            },
        },
        backgroundColor: 'rgb(0,0,0)',
    });
}

function initLeftTextAnimation(root: HTMLElement, leftText: HTMLElement) {
    gsap.set(leftText, { y: 50 });

    gsap.to(leftText, {
        scrollTrigger: {
            trigger: root,
            start: 'top top+=20%',
            end: 'top top+=20%',
            // toggleActions: 'restart', // 控制动画的开始和结束行为
            // markers: true,
        },
        y: 0,
        duration: 1,
    });
}

function initRightTextAnimation(
    root: HTMLElement,
    rightTextContainer: HTMLElement,
    rightText: HTMLElement,
) {
    const containerHeight = rightTextContainer.getBoundingClientRect().height;
    const textHight = rightText.getBoundingClientRect().height;

    gsap.set(rightText, { y: containerHeight * 0.8 });

    return gsap.to(rightText, {
        scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: '+=100%',
            scrub: true,
            // markers: {
            //     indent: 200,
            // },
        },
        y: -(textHight - containerHeight * 0.6),
    });

    // const tl = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: rightText,
    //         start: 'top bottom',
    //         end: 'bottom bottom',
    //         scrub: true,
    //         markers: true,
    //     },
    // });

    // tl.from(rightText, { opacity: 0, duration: 1 });
    // tl.to(rightText, { yPercent: -70, duration: 9 });
}

export default function initAnimation(
    root: HTMLElement,
    leftText: HTMLElement,
    rightTextContainer: HTMLElement,
    rightText: HTMLElement,
) {
    initRootAnimation(root);
    initLeftTextAnimation(root, leftText);
    let rightTextTween = initRightTextAnimation(
        root,
        rightTextContainer,
        rightText,
    );

    const handleResize = createStableResizeHandler(() => {
        rightTextTween.scrollTrigger?.kill();
        rightTextTween.kill();
        rightTextTween = initRightTextAnimation(
            root,
            rightTextContainer,
            rightText,
        );
    });
    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
        rightTextTween.scrollTrigger?.kill();
        rightTextTween.kill();
    };
}
